import {
    RpServiceConfigurationPolicyConfig,
    RpServiceConfigurationPolicyConfigDecision,
    RpServiceConfigurationPolicyConfigDecisionCondition
} from "@idw-types/data/rp-service-configuration";
import { WorkflowTemplateDetailsTemplatePolicyConfig } from "@idw-types/data/workflow-template-details";
import { formatRpServiceConfigurationPolicyConfig } from "../rp-services/rp-service-configuration-policy-config-formatter";
import { DeployedPolicyComponent } from "@idw-types/data/reference-data/generic";
import { AxnAttributeTypeField } from "@idw-types/data/reference-data/axn";
import { v4 as uuidv4 } from "uuid";


export const convertWorkflowTemplateDetailsPolicyConfigToFormattedRpServiceConfiguartionPolicyConfig = (
    pc: WorkflowTemplateDetailsTemplatePolicyConfig,
    deployedPolicyComponents: Array<DeployedPolicyComponent>,
    axnAttributeTypeFields: Array<AxnAttributeTypeField>,
) => {

    const decisions: Array<RpServiceConfigurationPolicyConfigDecision> = pc.decisions.map(decision => {

        const conditions: Array<RpServiceConfigurationPolicyConfigDecisionCondition> = decision.conditions.map(condition => {
            const newCondition: RpServiceConfigurationPolicyConfigDecisionCondition = {
                assertionID: condition.assertionID ? `${condition.assertionID}` : null,
                attributeFieldID: condition.attributeFieldID ? `${condition.attributeFieldID}` : null,
                componentID: condition.componentID ? `${condition.componentID}` : null,
                description: null,
                id: `${condition.id}`,
                policyConditionOperator: condition.policyConditionOperator,
                result: condition.result,
                serviceOfferingID: condition.serviceOfferingID ? `${condition.serviceOfferingID}` : null,
                attributeFieldCategory: condition.attributeFieldCategory,
                attributeField2ID: condition.attributeField2ID,
                attributeField2Category: condition.attributeField2Category,
                step: condition.step,
                step2: condition.step2,
                values: condition.values
            };
            return newCondition;
        });

        return {
            conditions,
            description: decision.description,
            disposition: decision.disposition,
            id: `${decision.id}`,
            obligationValue: decision.obligationValue,
            policyDecisionOperationType: decision.policyDecisionOperationType,
            policyDecisionType: decision.policyDecisionType,
            retries: `${decision.retries}`,
            status: decision.status,
            uuid: uuidv4()
        };
    });


    const rpServicePolicyConfig: RpServiceConfigurationPolicyConfig = {
        id: `${pc.id}`,
        name: pc.name,
        decisions: decisions,
        defaultAction: pc.defaultAction,
        defaultActionRetries: `${pc.defaultActionRetries}`,
        description: pc.description,
        policyRetries: `${pc.policyRetries}`,
        rpAXNServiceID: `${pc.rpAXNServiceID}`,
        status: pc.status
    };

    return formatRpServiceConfigurationPolicyConfig(
        rpServicePolicyConfig,
        deployedPolicyComponents,
        axnAttributeTypeFields
    );
};